"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LightningSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M19 2.61a.532.532 0 0 0-.96-.38L7.1 18.14c-.11.17-.13.38-.04.56.09.18.27.29.47.29h9.12c.27 0 .5-.21.53-.48L19 2.6v.01z"></path><path d="M13 29.39a.532.532 0 0 0 .96.38L24.9 13.86c.11-.17.13-.38.04-.56a.522.522 0 0 0-.47-.29h-9.12c-.27 0-.5.21-.53.48L13 29.4v-.01z"></path>';
var LightningSVG = function LightningSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LightningSVG = LightningSVG;
LightningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LightningSVG);
exports.default = _default;